export const getKeysWithUpdatedValues = <
  U = Record<string, any>,
  P = Record<string, any>
>(
  objUpdated: U,
  objPrev: P
) =>
  Object.keys(objUpdated as Object).filter(
    (key: string) => (objUpdated as any)[key] !== objPrev![key as keyof P]
  ) as Array<keyof U>;
